import React from "react";
import type { RouteObject } from "react-router-dom";
import AgentProfileEditMainPage from "./pages/profile-main/AgentProfileEditMainPage";
import AwardViewMorePage from "./pages/award-view-more/AwardViewMorePage";
import ErrorPage from "./pages/error-screen/ErrorPage";
import { EventFeature, EventModule, TrackingData } from "../../utils/event-tracking/event-tracking.model";

const trackingData: TrackingData = {
  name: "prospect::view_profile",
  module: EventModule.agent_profile_site,
  feature: EventFeature.agent_info,
  journey: "home",
}

export const routesAgentProfile: RouteObject[] = [
  { path: "profile-home", index: true, element: <AgentProfileEditMainPage {...trackingData}/> },
  { path: "award-view-more", element: <AwardViewMorePage /> },
  // { path: "error", element: <ErrorPage /> },
];
